import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { LetModule } from '@pu/directives';
import { UserProfileModule } from '@pu/components';
import { IconModule, NavItemModule } from '@pu/ui';
import { SearchInputModule } from '@pu/forms';

import { SupportModule } from '../../components/support/support.module';
import { MenuComponent } from './menu.component';
import { switcherComponent } from '../components/switcher/switcher.component';
import { GlobalSearchModule } from '../components/global-search/global-search.module';
import { BirthdaysWidgetModule } from '../components/birthdays-widget/birthdays-widget.module';

@NgModule({
  declarations: [MenuComponent, switcherComponent],
  imports: [
    CommonModule,
    SearchInputModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    LetModule,
    IconModule,
    UserProfileModule,
    NavItemModule,
    GlobalSearchModule,
    BirthdaysWidgetModule,
    RouterLink,
    SupportModule,
  ],
  exports: [MenuComponent],
})
export class MenuModule {}
